import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column h-100"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-fill flex-column align-items-center justify-content-center opacity-50"
}
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "m-0" }
const _hoisted_6 = { style: {"opacity":"0.6"} }
const _hoisted_7 = { class: "m-0" }
const _hoisted_8 = { class: "w-100" }
const _hoisted_9 = { class: "m-0 w-100 d-flex" }
const _hoisted_10 = { class: "ms-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.event)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.image && _ctx.minify !== true)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.image,
              class: "card-img-top",
              alt: _ctx.event.title
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.optionSelected.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "fas fa-ticket-alt ticket-icon" }, null, -1),
              _createElementVNode("h5", null, "Agrega tickets a tu carrito", -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.optionSelected.length > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              id: "resume-container",
              class: _normalizeClass(["flex-fill", _ctx.minify ? 'p-2' : 'p-4'])
            }, [
              _createElementVNode("h6", {
                class: _normalizeClass(["mt-2", _ctx.minify ? 'mb-2' : 'mb-5'])
              }, "Resumen del pedido", 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionSelected, (option) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "d-flex align-items-center justify-content-between border-top px-2 py-3",
                  key: option.id
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h6", _hoisted_4, _toDisplayString(option.name), 1),
                    _createElementVNode("p", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.format_currency(option.price)), 1),
                      _createElementVNode("strong", null, " X " + _toDisplayString(option.quantity), 1)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.format_currency(option.price, option.total)), 1)
                ]))
              }), 128)),
              _createElementVNode("div", {
                class: _normalizeClass(["d-flex align-items-center justify-content-between border-top px-2 py-3", _ctx.minify ? 'pb-0' : 'pt-5 pb-4'])
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h4", _hoisted_9, [
                    _cache[1] || (_cache[1] = _createTextVNode("Gran total: ", -1)),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.format_currency(null, _ctx.grand_total)), 1)
                  ])
                ])
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}